import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl, Button, Modal } from 'react-bootstrap';
import s from '../ManageBanner/ManageBannerList.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getShopCategoryIcons, addShopCategoryIcon, editShopCategoryIcon, deleteShopCategoryIcon } from '../../../actions/ShopCategoryIcon/ShopCategoryIconActions';
import history from '../../../history';
import IconDropzone from './IconDropzone';
import { api, shopCategoryIconUploadDir } from '../../../config';

class ManageShopCategoryIcon extends React.Component {
  static propTypes = {
    placements: PropTypes.array,
    getShopCategoryIcons: PropTypes.func.isRequired,
    addShopCategoryIcon: PropTypes.func.isRequired,
    editShopCategoryIcon: PropTypes.func.isRequired,
    deleteShopCategoryIcon: PropTypes.func.isRequired,
  };

  state = {
    showModal: false,
    isEdit: false,
    iconId: null,
    iconName: '',
    iconUrl: '',
    search: '',
  };

  componentDidMount() {
    this.props.getShopCategoryIcons();
  }

  openModal = (icon = null) => {
    if (icon) {
      this.setState({
        showModal: true,
        isEdit: true,
        iconId: icon.id,
        iconName: icon.name,
        iconUrl: icon.icon,
      });
    } else {
      this.setState({
        showModal: true,
        isEdit: false,
        iconId: null,
        iconName: '',
        iconUrl: '',
      });
    }
  };

  closeModal = () => {
    this.setState({ showModal: false, iconId: null, iconName: '', iconUrl: '', isEdit: false });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });
  };

  handleSave = async () => {
    const { iconName, iconUrl, isEdit, iconId } = this.state;
    const payload = {
      name: iconName,
      icon: iconUrl
    };
    if (isEdit) {
      await this.props.editShopCategoryIcon({ id: iconId, ...payload });
    } else {
      await this.props.addShopCategoryIcon(payload);
    }
    this.closeModal();
    await this.props.getShopCategoryIcons();
  };

  handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this icon?')) {
      await this.props.deleteShopCategoryIcon(id);
      await this.props.getShopCategoryIcons();
    }
  };

  render() {
    const { placements = [] } = this.props;
    const { showModal, iconName, iconUrl, isEdit, search } = this.state;
    // Filter placements by name
    const filteredPlacements = placements.filter(icon =>
      icon.name && icon.name.toLowerCase().includes(search.toLowerCase())
    );
    const baseUrl = api.apiEndpoint;
    const imageBaseUrl = baseUrl
    return (
      <div className={s.root}>
        <div className={s.widthInner}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 20
            }}
          >
            <div style={{alignItems: "center", gap: 12 }}>
              <Button
                variant="outline-secondary"
                type="button"
                onClick={() =>
                  history && history.push && history.push("/siteadmin")
                }
                style={{ marginBottom: 16, fontWeight: 600 }}
              >
                &#8592; Go Back
              </Button>
              <h3 style={{ margin: 0 }}>Manage Shop Category Icons</h3>
            </div>
            <Button onClick={() => this.openModal()} className={s.addlinkBtn}>
              + Add Icon
            </Button>
          </div>
          {/* Search input */}
          <div style={{ marginBottom: 16, maxWidth: 320 }}>
            <FormControl
              type="text"
              placeholder="Search by name..."
              value={search}
              onChange={this.handleSearchChange}
              style={{ borderRadius: 8, height: 40 }}
            />
          </div>
          <Table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Icon</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredPlacements && filteredPlacements.length > 0 ? (
                filteredPlacements.map((icon, idx) => (
                  <tr key={icon.id}>
                    <td>{idx + 1}</td>
                    <td>{icon.name}</td>
                    <td>
                      {icon.icon ? (
                        <img src={icon.icon.startsWith('http') ? icon.icon : `${imageBaseUrl}${shopCategoryIconUploadDir}${icon.icon}`} alt={icon.name} style={{ width: 40, height: 40, objectFit: 'contain' }} />
                      ) : (
                        <span>No icon</span>
                      )}
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="info"
                        onClick={() => this.openModal(icon)}
                        style={{ marginRight: 8 }}
                      >
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="danger"
                        onClick={() => this.handleDelete(icon.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No icon found.</td>
                </tr>
              )}
            </tbody>
          </Table>
          <Modal show={showModal} onHide={this.closeModal}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isEdit ? "Edit Icon" : "Add Icon"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ marginBottom: 16 }}>
                <label
                  htmlFor="iconNameInput"
                  style={{ marginBottom: 6, display: "block", fontWeight: 500 }}
                >
                  Name
                </label>
                <FormControl
                  id="iconNameInput"
                  name="iconName"
                  type="text"
                  placeholder="Name"
                  value={iconName}
                  onChange={this.handleChange}
                  style={{ borderRadius: 8, height: 40 }}
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ marginBottom: 6, display: "block", fontWeight: 500 }} htmlFor=''>
                  Icon Image
                </label>
                {/* Preview icon */}
                {iconUrl && (
                  <div style={{ marginBottom: 8 }}>
                    <img
                      src={iconUrl.startsWith('http') ? iconUrl : `${imageBaseUrl}${shopCategoryIconUploadDir}${iconUrl}`}
                      alt="icon preview"
                      style={{ width: 48, height: 48, objectFit: 'contain', border: '1px solid #eee', borderRadius: 8 }}
                    />
                  </div>
                )}
                <IconDropzone
                  onUploadSuccess={fileName => {
                    const finalUrl = `${imageBaseUrl}${shopCategoryIconUploadDir}${fileName}`;
                    this.setState({ iconUrl: fileName });
                  }}
                  defaultMessage={iconUrl ? 'Change Icon' : 'Upload Icon'}
                  subText="PNG, JPG, JPEG, SVG. Max 2MB."
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.closeModal}
                style={{ borderRadius: 8, minWidth: 90 }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={this.handleSave}
                disabled={
                  !iconName.trim() ||
                  !iconUrl.trim()
                }
                style={{ borderRadius: 8, minWidth: 90 }}
              >
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  placements: state.adminShopCategoryIcons && state.adminShopCategoryIcons.placements
});

const mapDispatch = (dispatch) => bindActionCreators({ getShopCategoryIcons, addShopCategoryIcon, editShopCategoryIcon, deleteShopCategoryIcon }, dispatch);

export default connect(mapState, mapDispatch)(withStyles(s)(ManageShopCategoryIcon)); 